import React, { FC } from "react";
import { checkSDHSync } from "@shared/utils";
import { StationConnectionResult } from "@containers/Station/interfaces";

import "./index.scss";

interface TrackingTimeRangeWarningProps {
  stationConnection: StationConnectionResult | null;
  isLoading: boolean;
}

const TrackingTimeRangeWarning: FC<TrackingTimeRangeWarningProps> = ({ stationConnection, isLoading }) => {
  const isValidTrackingTimeRange = checkSDHSync(stationConnection);

  if (isLoading || !stationConnection || isValidTrackingTimeRange) return null;

  return (
    <div className="tracking-time-range-warning">
      The time tracking range is not synchronized with Ingestor.
      <br /> Please set up new values.
    </div>
  );
};

export default TrackingTimeRangeWarning;
